var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-auto mx-auto"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Please wait"}}),(_vm.message)?_c('span',{staticClass:"ms-3 mt-1"},[_vm._v(_vm._s(_vm.message))]):_c('span',{staticClass:"ms-3 mt-1"},[_vm._v("Loading ... Please wait")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }